module.exports = __webpack_public_path__ + "img/put-inactive.1ec82eaf.svg";